import {Controller} from '@stubhub/react-store-provider';
import SessionHelper from '@stubhub/session-helper';

const NAMESPACE = 'headerNav';

const controller = new Controller({
  namespace: NAMESPACE,
  actionCreators: {
    signOutUser
  },
  mapStateToProps: function(state) {
    const vaFeature = state['virtual_assistant'] || {};
    return {
      webphoneEnabled: vaFeature.webphoneEnabled,
      inbentaEnabled: vaFeature.inbentaEnabled
    };
  }
});

// The use of cookies, session data, and post calls here makes unit test coverage complicated to mock
/* istanbul ignore next */
function signOutUser(domain) {
  return (dispatch) => {
    return SessionHelper.logout({domain});
  };
}

export default controller;
